<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pt-9 text-sm">
        <div class="flex items-center space-x-3 text-xs"></div>
        <div class="flex items-center space-x-3 text-xs"></div>
    </div>
    
    <div class="w-700-px mx-auto">
        <form [formGroup]="updateForm">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 space-y-5">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-60-px font-semibold">
                            Title:
                        </span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            type="text" 
                            placeholder="Title" 
                            formControlName="title"
                        >
                    </div>
                    
                    <div class="card-input flex items-start text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">
                            Message:
                        </span>
                        <textarea 
                            formControlName="message" 
                            class="placeholder-black focus:outline-none w-full h-70-px bg-gray-100 rounded-md pl-3 resize-none italic" 
                            placeholder="Message" 
                            name="" 
                            id="" 
                            cols="30" 
                            rows="10"
                        ></textarea>
                    </div>
                    
                    <div class="w-full flex flex-row justify-between gap-4">
                        <div class="flex flex-row justify-between w-full">
                            <div class="flex flex-col text-xs font-semibold flex-1">
                                <div class="mb-2 flex flex-row gap-2">
                                    <span>Cover Image: </span>
                                    <input 
                                        formControlName="coverImage" 
                                        type='file' 
                                        class="hidden" 
                                        (change)="onSelectFileCover($event)" 
                                        #coverImgInitial
                                        accept="image/*"
                                    >
                                    <button 
                                        type="button" 
                                        class="browse-btn px-4 py-2 focus:outline-none" 
                                        (click)="coverImgInitial.click()"
                                    >
                                        Browse...
                                    </button>
                                </div>
                                <div *ngIf="cover_img" class="w-300-px b-violet">
                                    <img 
                                        *ngIf="cover_img" 
                                        [src]="cover_img" 
                                        class="w-full h-200-px object-contain" 
                                        alt="Cover Image"
                                    >
                                </div>
                            </div>

                            <div class="flex flex-col text-xs font-semibold flex-1">
                                <div class="mb-2 flex flex-row gap-2">
                                    <span>Featured Image: </span>
                                    <input 
                                        formControlName="featureImage" 
                                        type='file' 
                                        class="hidden" 
                                        (change)="onSelectFileFeatured($event)" 
                                        #featureImgInitial
                                        accept="image/*"
                                    >
                                    <button 
                                        type="button" 
                                        class="browse-btn px-4 py-2 focus:outline-none" 
                                        (click)="featureImgInitial.click()"
                                    >
                                        Browse...
                                    </button>
                                </div>
                                <div *ngIf="feature_img" class="w-300-px b-violet">
                                    <img 
                                        *ngIf="feature_img" 
                                        [src]="feature_img" 
                                        class="w-full h-200-px object-contain" 
                                        alt="Featured Image"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="w-full flex items-center justify-center mt-6 mb-4 space-x-3">
        <button 
            (click)="cancel()" class="uppercase custom-btn btn-white-orange font-bold text-xs px-6 py-2"
        >
            Cancel
        </button>
        <button 
            [disabled]="isSubmitDisabled()" 
            [matTooltip]="isSubmitDisabled() ? 'No changes to save' : ''"
            [ngClass]="isSubmitDisabled() ? 'bg-gray-400 cursor-not-allowed opacity-70' : 'btn-dark-orange'" 
            (click)="update()" 
            class="uppercase custom-btn font-semibold text-xs px-6 py-2"
        >
            Update
        </button>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>